module.exports = require('./helpers/bundle-url').getBundleURL('dj12v') + "curate-image.d1f1c2c8.png";